<template>
  <div class="sip_ui_border sip_notification_border">
    <div class="sip_notification sip_ui_body">
      <div class="sip_notification_item sip_notification_item_left" v-show="notify === 1" data-id="1">
        <div class="sip_notification_item_el">
          <img v-if="!$isMob" :srcset="`${$server}notification1.png 1x, ${$server}notification1_2x.png 2x`" :src="`${$server}notification1.png`" />
          <img v-if="$isMob" :srcset="`${$server}notification1_mob.png 1x, ${$server}notification1_mob_2x.png 2x`" :src="`${$server}notification1_mob.png`" />
          <span>Вижу судно на горизонте!</span>
        </div>
      </div>
      <div class="sip_notification_item sip_notification_item_right" v-show="notify === 2" data-id="2">
        <div class="sip_notification_item_el">
          <img v-if="!$isMob" :srcset="`${$server}notification2.png 1x, ${$server}notification2_2x.png 2x`" :src="`${$server}notification2.png`" />
          <img v-if="$isMob" :srcset="`${$server}notification2_mob.png 1x, ${$server}notification2_mob_2x.png 2x`" :src="`${$server}notification2_mob.png`" />
          <span>Вернитесь для заправки судна!</span>
        </div>
      </div>
      <div class="sip_notification_item sip_notification_item_right" v-show="notify === 3" data-id="3">
        <div class="sip_notification_item_el">
          <img v-if="!$isMob" :srcset="`${$server}notification3.png 1x, ${$server}notification3_2x.png 2x`" :src="`${$server}notification3.png`" />
          <img v-if="$isMob" :srcset="`${$server}notification3_mob.png 1x, ${$server}notification3_mob_2x.png 2x`" :src="`${$server}notification3_mob.png`" />
          <span>Разрази меня гром!<br>Мое топливо — ром!</span>
        </div>
      </div>
      <div class="sip_notification_item sip_notification_item_right" v-show="notify === 4" data-id="4">
        <div class="sip_notification_item_el">
          <img v-if="!$isMob" :srcset="`${$server}notification4.png 1x, ${$server}notification4_2x.png 2x`" :src="`${$server}notification4.png`" />
          <img v-if="$isMob" :srcset="`${$server}notification4_mob.png 1x, ${$server}notification4_mob_2x.png 2x`" :src="`${$server}notification4_mob.png`" />
          <span>Жду своего капитана...<br>Поспеши! ;)</span>
        </div>
      </div>
      <div class="sip_notification_item sip_notification_item_right" v-show="notify === 5" data-id="5">
        <div class="sip_notification_item_el">
          <img v-if="!$isMob" :srcset="`${$server}notification5.png 1x, ${$server}notification5_2x.png 2x`" :src="`${$server}notification5.png`" />
          <img v-if="$isMob" :srcset="`${$server}notification5_mob.png 1x, ${$server}notification5_mob_2x.png 2x`" :src="`${$server}notification5_mob.png`" />
          <span>Швартоваться<br>правым бортом!</span>
        </div>
      </div>
      <div class="sip_notification_item sip_notification_item_right" v-show="notify === 6" data-id="6">
        <div class="sip_notification_item_el">
          <img v-if="!$isMob" :srcset="`${$server}notification6.png 1x, ${$server}notification6_2x.png 2x`" :src="`${$server}notification6.png`" />
          <img v-if="$isMob" :srcset="`${$server}notification6_mob.png 1x, ${$server}notification6_mob_2x.png 2x`" :src="`${$server}notification6_mob.png`" />
          <span>Видите облако дыма?<br/>Это судно ходит на традиционном топливе&nbsp;—&nbsp;увы, СПГ ему&nbsp;не подходит.</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Notification',
  data() {
    return {
    }
  },
  props: ['notify'],
}
</script>

<style lang="stylus">
.sip_notification
  position relative
  height 75px
  .sip_notification_item
    position relative
    position absolute
    bottom -4px
    left 5px
    span
      position absolute
      bottom 11px
      left 0
      width 174px
      height 47px
      padding 8px
      font-weight 500
      font-size 14px
      line-height 115%
      z-index 2

.sip_ui
  .sip_ui_border.sip_notification_border
    @media screen and (max-width: 900px)
      box-shadow none
      background-color transparent
      padding 0
    .sip_notification
      @media screen and (max-width: 900px)
        box-shadow none
        background-color transparent
        padding 0
        height auto
      .sip_notification_item
        @media screen and (max-width: 900px)
          width 100%
          position absolute
          bottom -4px
          left 0
          text-align: right
          padding 0 20px
          .sip_notification_item_el
            position absolute
            bottom 0
          span
            position: absolute
            bottom 7px
            right 82px
            left unset
            background-color #FFF
            box-shadow 0px 3px 0px rgba(0, 0, 0, 0.1)
            border-radius 6px
            width auto
            height auto
            white-space pre
            &:after
              top 50%
              border solid transparent
              content ""
              height 0
              width 0
              position absolute
              pointer-events none
              border-color rgba(255, 255, 255, 0)
              border-width 11px
              margin-top -22px
      .sip_notification_item_left
        @media screen and (max-width: 900px)
          .sip_notification_item_el
            left 20px
            right unset
            span
              left 90px
              right unset
      .sip_notification_item_right
        @media screen and (max-width: 900px)
          .sip_notification_item_el
            right 20px
            left unset
            span
              right 82px
              left unset
              text-align left
  .sip_notification_item[data-id="6"]
    span
      bottom 11px
      left 0
      height 90px
      padding 8px
      @media screen and (max-width: 900px)
        width 270px !important
        white-space pre-wrap !important

</style>